module.exports = __webpack_public_path__ + "static/media/paper.61a3b024.svg";